<template>
	<div :class="['c-available-now', className]">
		<div class="o-width-limiter o-width-limiter--main">
			<div class="c-available-now__wrapper">
				<div class="c-available-now__content">
					<h2 class="c-available-now__heading heading-boarder">{{ heading }}</h2>
					<ul class="c-available-now__list">
						<slot></slot>
					</ul>
				</div>
				<img
					src="/gui/images/roof-blue.svg"
					class="c-available-now__roof"
					alt=""
					aria-hidden="true"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "VAvailableNowBlock",
	props: {
		heading: { type: String },
		className: { type: String }
	}
};
</script>
